import { render, staticRenderFns } from "./SessionCard.vue?vue&type=template&id=6adb65c5&scoped=true&"
import script from "./SessionCard.vue?vue&type=script&lang=js&"
export * from "./SessionCard.vue?vue&type=script&lang=js&"
import style0 from "./SessionCard.vue?vue&type=style&index=0&id=6adb65c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adb65c5",
  null
  
)

export default component.exports